import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { TranslationData } from '../../shared/interfaces/translate.interface';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  private http = inject(HttpClient);
  private translationsData = signal<TranslationData>({});

  public loadDefaultTranslations(): Observable<void> {
    return this.http.get<TranslationData>('/i18n/en.json').pipe(
      tap((data) => this.translationsData.set(data)),
      map(() => void 0),
      catchError((err) => {
        // eslint-disable-next-line no-console
        console.error('Critical: Failed to load en.json translation file', err);
        return of(void 0);
      }),
    );
  }

  public getTranslation(key: string): string {
    const data = this.translationsData();
    if (!key || !data) return key;

    const result = key.split('.').reduce<unknown>((obj, property) => {
      if (obj && typeof obj === 'object' && property in obj) {
        return (obj as Record<string, unknown>)[property];
      }
      return undefined;
    }, data);

    return typeof result === 'string' ? result : key;
  }
}
